import { render, staticRenderFns } from "./Replies.vue?vue&type=template&id=50a4fe61&"
import script from "./Replies.vue?vue&type=script&lang=js&"
export * from "./Replies.vue?vue&type=script&lang=js&"
import style0 from "./Replies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports